import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bullet",
  "use": "icon-bullet-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" fill=\"currentColor\" id=\"icon-bullet\">\r\n    <circle cx=\"9\" cy=\"9\" r=\"9\" stroke=\"none\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol